export default [{
  path: '/question-type-list',
  name: 'questionTypeList',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/quiz/questionTypeList/index')
}]
